import { MasterDetailListEntry } from "@sdbn/common";

export class IssueType implements MasterDetailListEntry {
  id: number;
  nameDictionaryKey: string;
  translatedLabel: string;

  constructor(issueType: any) {
    this.id = issueType.id;
    this.nameDictionaryKey = issueType.nameDictionaryKey;
  }

  public get listTitle(): string {
    return this.translatedLabel;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }
}
